import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HashRouter>
      <Routes>
        {/* Si aucune langue dans l'URL → redirection vers /fr */}
        <Route path="/" element={<Navigate to="/es" replace />} />
        
        {/* Route dynamique : fonctionne pour fr, en, es, de, ar, etc. */}
        <Route path="/:lang/*" element={<App />} />
      </Routes>
    </HashRouter>
  </StrictMode>
);
